import { render, staticRenderFns } from "./samlLoginPage.vue?vue&type=template&id=d20dbe5c"
import script from "./samlLoginPage.vue?vue&type=script&lang=js"
export * from "./samlLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports